var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGeobizIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 319,
    height: 355,
    viewBox: "0 0 319 355",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M301.94 298.3L302.36 297.9V297.28C302.36 286.8 297.02 277.72 288.41 273.58C280.82 269.93 272.23 270.99 265.44 276.41C235.95 299.96 201.23 312.41 165.04 312.41C128.85 312.41 94.1703 299.97 64.6803 276.44C57.9303 271.05 49.3903 270.01 41.8303 273.65C33.1903 277.81 27.8203 286.92 27.8203 297.43V298.01L28.2403 298.41C66.4603 334.78 115.04 354.81 165.04 354.81C215.04 354.81 263.71 334.74 301.94 298.3Z",
    fill: "#01A577"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M286.36 122.32C286.36 56.0301 232.71 2.1001 166.76 2.1001C100.81 2.1001 47.1602 56.0301 47.1602 122.32C47.1602 154.01 59.4402 182.86 79.4502 204.36H79.3402L81.5002 206.52C81.9902 207.02 82.4902 207.52 82.9902 208.02L155.59 281C161.76 287.2 171.75 287.2 177.92 281L250.52 208.02C251.02 207.52 251.52 207.02 252.01 206.52L254.17 204.35H254.06C274.07 182.86 286.35 154.01 286.35 122.32H286.36ZM164.53 277.32L146.85 260.62L160.85 227.71L170.18 227.46L181.23 259.63L164.53 277.31V277.32ZM170.43 224.27H160.61L149.8 204.62L181.24 205.6L170.43 224.27ZM166.76 194.29C127.28 194.29 95.1602 162 95.1602 122.31C95.1602 82.6201 127.28 50.3401 166.76 50.3401C206.24 50.3401 238.36 82.6301 238.36 122.31C238.36 161.99 206.24 194.29 166.76 194.29Z",
    fill: "#01A577"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGeobizIcon);
export default __webpack_public_path__ + "static/media/geobiz_icon.7c3041cb01095205dcac65d9fa5b52a8.svg";
export { ForwardRef as ReactComponent };